<template>
  <button class="sidebar-minimizer" type="button" @click="sidebarMinimize();brandMinimize()"><span v-if="hide==1" class="ml-auto">Fusion © {{ getCurrentYear }}</span></button>
</template>

<script>
export default {
  name: 'sidebar-minimizer',
  data: function () {
    return {
      hide: 1
    }
  },
  methods: {
    sidebarMinimize () {
      document.body.classList.toggle('sidebar-minimized')
      this.hide = this.hide ? 0 : 1
    },
    brandMinimize () {
      document.body.classList.toggle('brand-minimized')
    }
  }
}
</script>

<style scoped>
  .sidebar-minimizer .ml-auto{
    float: left;
    color: #fff;
    padding-left: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Sidebar/SidebarMinimizer.vue